// extracted by mini-css-extract-plugin
export var active = "_bz-2";
export var highlight = "_bz-1";
export var highlightLayer = "_bz-0";
export var issuePopover = "_bz-3";
export var statusIcon = "_bz-4";